import type { SemboMarket } from '../../../apps/explore/utils/markets';

export const DEFAULT_SEMBO_MARKET: SemboMarket = {
  host: 'www.sembo.com',
  lang: 'en',
  countryISO: 'US',
  countryName: 'USA',
  currency: {
    symbol: '$',
    code: 'USD',
  },
};
